var state = {
    franchisor: {}
};
var getters = {
    getFranchisor: function (state) {
        return state.franchisor;
    }
};
var actions = {
    setFranchisor: function (_a, franchisor) {
        var commit = _a.commit;
        commit("setFranchisor", franchisor);
    },
};
var mutations = {
    setFranchisor: function (state, franchisor) {
        state.franchisor = franchisor;
    }
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/franchisor.store.ts
// module id = null
// module chunks = 